
import { createSlice } from "@reduxjs/toolkit";

const companyEditSlice = createSlice({
  name: "companyEdit",
  initialState: {
    currentCompany: null,
    isFetching: false,
    error: false
  },
  reducers: {
    companyStart: (state) => {
      state.isFetching = true;
    },
    companySuccess: (state, action) => {
      state.isFetching = false;
      state.currentCompany = action.payload;
    },
    companyFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    updateStart: (state) => {
      state.currentCompany = null;
      state.isFetching = true;
      state.error = false;
    },
    updateSuccess: (state, action) => {
        state.isFetching = false;
        state.currentCompany = action.payload
        state.error = false;
    },
    updateFailure: (state) => {
        state.currentCompany = null;
        state.isFetching = false;
        state.error = true;
    },
    logoutCompany: (state) =>{
      state.currentCompany = null;
      state.isFetching = false;
      state.error = false;
    }
  },
});


export const { companyStart, companySuccess, companyFailure, updateStart, updateSuccess, updateFailure, logoutCompany } = companyEditSlice.actions;
export default companyEditSlice.reducer;